module.exports = __webpack_public_path__ + "img/_faq.08d2adec.svg";